import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from 'date-fns/locale';

const ContractTimeSelector = ({
  label,
  date,
  onDateChange,
  height,
  pt,
  mt,
  size = 'small',
  minWidth,
  variant = 'outlined',
  color = 'primary',
  flex,
}) => {
  return (
    <Box
      sx={{ mt: mt, pt: pt, minWidth: minWidth, height: height }}
      flex={flex}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
        <DatePicker
          label={label}
          value={date ? new Date(date) : null}
          onChange={(newValue) => {
            onDateChange(newValue);
          }}
          slotProps={{
            textField: {
              variant: variant,
              color: color,
              size: size,
              fullWidth: true,
              sx: { height: height },
            },
            actionBar: {
              actions: ['clear', 'cancel', 'accept'],
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default ContractTimeSelector;
